module.exports = __webpack_public_path__ + "img/spawner-die-mask-02.3b9b93a5.png";